import { createContext } from "react";

export interface TourContextValue {
  isRunning: boolean;
  startTour: () => void;
  stopTour: () => void;
  shouldShowOffer: boolean;
  dismissOffer: (dontShowAgain: boolean) => void;
  acceptOffer: () => void;
  registerNavigate: (navigate: (page: string) => void) => void;
  navigateTo: (page: string) => void;
}

export const TourContext = createContext<TourContextValue | null>(null);
